import React, { useState } from "react";
import { useQueryCache } from "react-query";
import useApiFetchInfinite from "src/Hooks/Shared/useApiFetchInfinite";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import FeedItem from "../FeedItem/FeedItem";
import InfiniteScroll from "react-infinite-scroll-component";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import useLoading from "src/Hooks/Custom/useLoading";
import PostDetail from "../PostDetail/PostDetail";
import { useParams, useRouteMatch } from "react-router-dom";
import ReportModal from "../ReportModal/ReportModal";
import PostModal from "../PostModal/PostModal";

type PostListProps = {
  endPoint: string, placeholderMessage: string, postData?: any, setPostData?: any, modalVisibility?: boolean, setModalVisibility?: any, groupId?: number, is_private?: boolean, postId?: any, search?: string
}

function PostList({ endPoint, placeholderMessage, postData, setPostData, modalVisibility, setModalVisibility, groupId, is_private, postId: pId, search }: PostListProps) {
  const [reportData, setReportData] = useState<any>();
  const [showReportModal, setShowReportModal] = useState<boolean>(false)
  const { path } = useRouteMatch();
  const params: any = useParams();
  const postId = !path.includes('/groups/:id') && Object.keys(params).length !== 0 && params.constructor === Object ? params.id : pId;
  const { user } = AppStateHandler.getState();
  const queryCache = useQueryCache();
  const Url = groupId !== undefined
    ? `${endPoint}?subId=${user?.username}&groupId=${groupId}`
    : `${endPoint}?subId=${user?.username}`;

  const { data, refetch, status, fetchMore } = useApiFetchInfinite(
    [
      search !== ''
        ? `${Url}&search=${search}`
        : Url,
    ],
    {
      getFetchMore: (lastData) => {
        const nextPage = lastData?.data?.Page;
        const totalPages = lastData?.data?.TotalPages;

        return parseInt(nextPage ?? "1", 10) < totalPages
          ? `&page=${parseInt(nextPage ?? "1", 10) + 1}`
          : null;
      },
    }
  );
  useLoading(status);
  
  const toggleLike = (_index: number, _item: any) => {
    queryCache.setQueryData(
      `${endPoint}?subId=${user?.username}`,
      (oldData: any = []) => {
        const tempData = [...oldData];
        const [firstItem] = oldData;
        if (firstItem) {
          const count = firstItem?.data?.Count ?? 5;
          const currentBlockIndex = Math.floor(_index / count);
          const currentItemIndex = _index % count;
          tempData[currentBlockIndex].data.Items[currentItemIndex] = {
            ..._item,
            is_like: _item?.is_like === 0 ? 1 : 0,
          };
        }
        return tempData;
      }
    );
  };

  const arrayData = (Array.isArray(data) ? data : [])
    .map((_) => _.data.Items)
    .reduce((a, b) => a.concat(b), []);

  if (status !== "loading" && arrayData?.length === 0) {
    return <p className="text-center">{placeholderMessage}</p>;
  }

  return (
    <>
      {
        postId ?
          <PostDetail
            postId={postId}
            groupId={groupId}
            postData={postData}
            setPostData={setPostData}
            setModalVisibility={setModalVisibility}
          />
          :
          <>
            <InfiniteScroll
              dataLength={arrayData.length} //This is important field to render the next data
              next={fetchMore}
              hasMore={true}
              loader={
                <VisibilityToggle visible={arrayData?.length !== 0 && status === 'loading'}>
                  <span className="spinner-border spinner-border-lg text-center"></span>
                </VisibilityToggle>
              }
              endMessage={
                <p className="text-center">
                  <b>Yay! You have seen it all</b>
                </p>
              }
              // below props only if you need pull down functionality
              refreshFunction={refetch}
              pullDownToRefresh
              pullDownToRefreshThreshold={50}
              pullDownToRefreshContent={
                <h6 className="text-center">&#8595; Pull down to refresh</h6>
              }
              releaseToRefreshContent={
                <h6 className="text-center">&#8593; Release to refresh</h6>
              }
            >
              {(is_private ? [] : arrayData).map((item: any, index: number) => (
                <FeedItem
                  key={index}
                  {...item}
                  toggleLike={() => toggleLike(index, item)}
                  refetch={refetch}
                  setPostData={setPostData}
                  setModalVisibility={setModalVisibility}
                  setReportData={setReportData}
                  setShowReportModal={setShowReportModal}
                />

              ))}
              <VisibilityToggle visible={data?.length === 0 && arrayData?.length !== 0 && status === "loading"}>
                <span className="spinner-border spinner-border-lg text-center"></span>
              </VisibilityToggle>
            </InfiniteScroll>
            {showReportModal ? (
              <ReportModal
                data={reportData.data}
                setData={setReportData}
                type={reportData.type}
                showModal={showReportModal}
                setModalVisibility={setShowReportModal}
                endPoint={reportData.endPoint}
              />
            ) : (
                <></>
              )}
          </>
      }
      {
        modalVisibility ? (
          <PostModal
            postData={postData}
            setPostData={setPostData}
            showModal={modalVisibility}
            setModalVisibility={setModalVisibility}
            refetch={refetch}
          />
        ) : (
            <></>
          )
      }
    </>

  );
}

export default PostList;
